/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcribe_Too_LargeInputs */

const en_us2_transcribe_too_large = /** @type {(inputs: Transcribe_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That recording is too long. Try a shorter message.`)
};

const pt_br2_transcribe_too_large = /** @type {(inputs: Transcribe_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa gravação ficou longa demais. Tente uma mensagem mais curta.`)
};

const es_419_transcribe_too_large = /** @type {(inputs: Transcribe_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa grabación es demasiado larga. Prueba con un mensaje más corto.`)
};

const pt_pt2_transcribe_too_large = /** @type {(inputs: Transcribe_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa gravação ficou demasiado longa. Tenta uma mensagem mais curta.`)
};

const fr_fr2_transcribe_too_large = /** @type {(inputs: Transcribe_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet enregistrement est trop long. Essaie un message plus court.`)
};

const de_de2_transcribe_too_large = /** @type {(inputs: Transcribe_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Aufnahme ist zu lang. Versuch eine kürzere Nachricht.`)
};

const it_it2_transcribe_too_large = /** @type {(inputs: Transcribe_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La registrazione è troppo lunga. Prova con un messaggio più breve.`)
};

/**
* | output |
* | --- |
* | "That recording is too long. Try a shorter message." |
*
* @param {Transcribe_Too_LargeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const transcribe_too_large = /** @type {((inputs?: Transcribe_Too_LargeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcribe_Too_LargeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_transcribe_too_large(inputs)
	if (locale === "es-419") return es_419_transcribe_too_large(inputs)
	if (locale === "pt-PT") return pt_pt2_transcribe_too_large(inputs)
	if (locale === "fr-FR") return fr_fr2_transcribe_too_large(inputs)
	if (locale === "de-DE") return de_de2_transcribe_too_large(inputs)
	if (locale === "it-IT") return it_it2_transcribe_too_large(inputs)
	return en_us2_transcribe_too_large(inputs)
});
export { transcribe_too_large as "transcribe.too_large" }